import React, { useState } from "react";
import {
  makeStyles,
  Label,
  Dropdown,
  Option,
  OptionGroup,
  Spinner,
  useId,
} from "@fluentui/react-components";
import { FilterDismiss16Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  dropdown: {
    minWidth: 0,
    width: "100%",
  },
});

interface SalesPersonDropdownProps {
  salesPeople: string[];
  isLoading: boolean;
  selectedSalesPeople: string[];
  onSelectionChange: (salesPeople: string[]) => void;
}

export const SalesPersonDropdown: React.FC<SalesPersonDropdownProps> = ({
  salesPeople,
  isLoading,
  selectedSalesPeople,
  onSelectionChange,
}) => {
  const styles = useStyles();
  const labelId = useId("sales-person-label");
  const [isOpen, setIsOpen] = useState(false);
  let allSalesPeopleValue = "__all_sales_people__";
  while (
    salesPeople.includes(allSalesPeopleValue) ||
    selectedSalesPeople.includes(allSalesPeopleValue)
  ) {
    allSalesPeopleValue += "_";
  }

  return (
    <>
      <Label id={labelId} weight="semibold">
        Sales Person
      </Label>
      {isLoading ? (
        <Spinner size="tiny" />
      ) : (
        <Dropdown
          aria-labelledby={labelId}
          className={styles.dropdown}
          multiselect
          open={isOpen}
          onOpenChange={(_, data) => setIsOpen(data.open)}
          placeholder="All sales persons"
          value={
            selectedSalesPeople.length > 0
              ? `${selectedSalesPeople.length} selected`
              : ""
          }
          selectedOptions={selectedSalesPeople}
          onOptionSelect={(_, data) => {
            if (data.optionValue === allSalesPeopleValue) {
              onSelectionChange([]);
              setIsOpen(false);
            } else {
              onSelectionChange(data.selectedOptions);
            }
          }}
          size="small"
        >
          <OptionGroup>
            <Option
              value={allSalesPeopleValue}
              text="Reset filter"
              disabled={selectedSalesPeople.length === 0}
              role="menuitem"
              aria-checked={undefined}
              checkIcon={null}
            >
              <FilterDismiss16Regular aria-hidden="true" />
              Reset filter
            </Option>
          </OptionGroup>
          <OptionGroup>
            {salesPeople.map((person) => (
              <Option key={person} value={person}>
                {person}
              </Option>
            ))}
          </OptionGroup>
        </Dropdown>
      )}
    </>
  );
};
